export default "__VITE_ASSET__Bz9UB6HU__"